import Header from './Header/Header'
import Footer from './Footer/Footer'
import styled from 'styled-components'
// import TrackingHint from './TrackingHint/TrackingHint'

type Props = {
  children: React.ReactNode
  className?: string
  hideNavigation?: boolean
  noFooter?: boolean
  headerTransparent?: boolean
  disableHeaderPadding?: boolean
  disableAbsoluteFooter?: boolean
}

const RedBG = styled.div`
  background: rgb(227, 0, 15);
  background: radial-gradient(circle, rgba(227, 0, 15, 1) 0%, rgba(170, 0, 7, 1) 100%);
`

const Layout: React.FC<Props> = ({
  children,
  className,
  hideNavigation,
  noFooter = false,
  headerTransparent = false,
  disableHeaderPadding = false,
  disableAbsoluteFooter = false,
}) => {
  return (
    <div className={`bg-background ${className}`}>
      <RedBG className={`min-h-screen flex flex-col justify-between`}>
        <Header headerTransparent={headerTransparent} hideNavigation={hideNavigation} />
        <div className={`flex flex-col justify-between overflow-x-hidden min-h-fit ${!disableHeaderPadding && 'pt-20'}`}>
          <div>{children}</div>
        </div>
        {!noFooter && <Footer />}
      </RedBG>
      {/* <TrackingHint /> */}
    </div>
  )
}

export default Layout
